import React from 'react';
import { MenuItem, MenuSurface } from './MenuSurface';

function ParallelMissionIcon() {
  return (
    <svg
      className="task-node__parallel-icon"
      viewBox="0 0 18 18"
      width="18"
      height="18"
      aria-hidden="true"
      focusable="false"
    >
      <path
        d="M9 0.8V3.2M4.5 6.5C4.5 5 9 5 9 3.2M13.5 6.5C13.5 5 9 5 9 3.2M4.5 11C4.5 12.5 9 12.5 9 14.3M13.5 11C13.5 12.5 9 12.5 9 14.3M9 14.3V17.2"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.25"
        strokeLinecap="round"
      />
      <rect x="2" y="6.5" width="5" height="4.5" rx="0.9" />
      <rect x="11" y="6.5" width="5" height="4.5" rx="0.9" />
    </svg>
  );
}

export function MissionMenu({
  menuRef,
  menuPosition,
  task,
  hasIcon,
  hasNestedSprint,
  onOpenDetails,
  onAddNoteOnHost,
  onAddMilestoneOnHost,
  onOpenAttachments,
  onFocusTask,
  onAddIcon,
  onCopy,
  onDuplicate,
  onCreateParallelMission,
  onOpenNestedSprint,
  onCreateNestedSprint,
  onExplode,
  onArchive,
  onUnarchive,
  onDelete,
  handleAction,
}) {
  const deliverables = task?.deliverables || [];
  const totalDeliverables = deliverables.length;
  const completedDeliverables = deliverables.filter(d => d.completed).length;
  const hasDeliverables = totalDeliverables > 0;
  const attachmentCount = task?.attachmentCount || 0;

  return (
    <MenuSurface menuRef={menuRef} menuPosition={menuPosition}>
      <MenuItem
        icon="📄"
        label={`Open Mission${hasDeliverables ? ` (${completedDeliverables}/${totalDeliverables})` : ''}`}
        onClick={handleAction(onOpenDetails)}
      />

      {onAddNoteOnHost && (
        <MenuItem
          type="button"
          icon="💬"
          label="Add Note"
          onClick={handleAction(() => onAddNoteOnHost(task.id))}
        />
      )}

      {onAddMilestoneOnHost && (
        <MenuItem
          type="button"
          icon="🚩"
          label="Add Milestone"
          onClick={handleAction(() => onAddMilestoneOnHost())}
        />
      )}

      <MenuItem
        icon="📎"
        label={`Attachments${attachmentCount > 0 ? ` (${attachmentCount})` : ''}`}
        onClick={handleAction(onOpenAttachments)}
      />
      {onFocusTask && (
        <MenuItem icon="🔍" label="Focus Task" onClick={handleAction(onFocusTask)} />
      )}

      {!hasIcon && (
        <MenuItem icon="🎨" label="Add Icon" onClick={onAddIcon} />
      )}

      <div className="task-node__drag-menu-divider" />

      <MenuItem icon="📋" label="Copy" shortcut="Ctrl+C" onClick={handleAction(onCopy)} />
      <MenuItem icon="⧉" label="Duplicate" shortcut="Ctrl+D" onClick={handleAction(onDuplicate)} />

      {onCreateParallelMission && task?.nodeType !== 'decision' && (
        <MenuItem
          icon={<ParallelMissionIcon />}
          label="Create Parallel Mission"
          onClick={handleAction(() => onCreateParallelMission(task.id))}
        />
      )}

      <div className="task-node__drag-menu-divider" />

      {hasNestedSprint ? (
        <MenuItem
          nested
          icon="⚔️"
          label="Open Campaign Inside Mission"
          onClick={handleAction(onOpenNestedSprint)}
        />
      ) : (
        <MenuItem
          icon="➕"
          label="Create Campaign Inside Mission"
          onClick={handleAction(onCreateNestedSprint)}
        />
      )}

      {hasNestedSprint && onExplode && (
        <MenuItem
          type="button"
          icon="💥"
          label="Explode nested campaign"
          onClick={onExplode}
        />
      )}

      <div className="task-node__drag-menu-divider" />

      {task?.archived ? (
        <MenuItem icon="📤" label="Restore from Archive" onClick={handleAction(onUnarchive)} />
      ) : (
        <MenuItem icon="📦" label="Archive" onClick={handleAction(onArchive)} />
      )}

      <MenuItem icon="🗑️" label="Delete" danger onClick={handleAction(onDelete)} />
    </MenuSurface>
  );
}
